import isFunction from 'lodash/isFunction';
import {
	RadioButton,
	RadioButtonChangeParams,
	RadioButtonProps,
} from 'primereact/radiobutton';
import React, { useCallback } from 'react';
import { SegmentEventTypes } from '../../data/tracking';
import Analytics from '../../utils/Analytics';

type WrappedRadioButtonProps = RadioButtonProps & {
	className?: string;
	dataqa?: string;
	segmentvalue?: string;
	inputId: string;
};

/**
 * WrappedRadioButton is a wrapper around the PrimeReact RadioButton component.
 * It adds analytics tracking and provides a consistent interface.
 */
export const WrappedRadioButton: React.FC<WrappedRadioButtonProps> = props => {
	const {
		children,
		inputId,
		className = '',
		dataqa = 'common',
		onChange,
		segmentvalue,
		...rest
	} = props;

	const clickHandler = useCallback(
		(e: RadioButtonChangeParams) => {
			Analytics.trackSegmentEvent({
				trackingData: {
					field_type: 'radiobutton',
					field_name_dataqa: `${dataqa}`,
					field_value: segmentvalue || e.target?.value,
				},
				eventType: SegmentEventTypes.UserInteraction,
			});

			if (isFunction(onChange)) {
				onChange(e);
			}
		},
		[onChange, dataqa, segmentvalue]
	);

	return (
		<div className={`common-ui-radiobutton ${className}`} data-qa={dataqa}>
			<RadioButton inputId={inputId} onChange={clickHandler} {...rest} />
			<label htmlFor={inputId} className="p-radiobutton-label">
				{children}
			</label>
		</div>
	);
};
